export default __webpack_public_path__ + "static/media/collect.a47faac2.jpg";